window.RyftPayModel = class RyftPayModel
{

    /** @type {RyftPayModel} */
    static instance = null;

    static getInstance() {
        if(this.instance !== null) {
            return this.instance;
        }
        this.instance = new RyftPayModel();
        return this.instance;
    }

    paymentSessionID = "";
}